import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import ConsultationPage from "./ConsultationPage";
import HospitalRegisterPage from "./HospitalRegisterPage";
import HospitalLoginPage from "./HospitalLoginPage";
import HospitalDashboard from "./HospitalDashboard";
import LandingPage from "./LandingPage";


function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hospitalSlug, setHospitalSlug] = useState("");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const docRef = doc(db, "hospitals", currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const name = docSnap.data().hospitalName;
          setHospitalSlug(name.toLowerCase().trim().replace(/\s+/g, '-'));
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div className="h-screen flex items-center justify-center font-bold">Loading Avaami...</div>;

  return (
    <Router>
      <Routes>
        {/* FIX: First run aagum pothu Landing Page thaan view aaganum */}
        <Route path="/" element={<LandingPage />} />

        {/* Register & Login: User already login-la irundha direct-ah dashboard poidum */}
        <Route 
          path="/register" 
          element={!user ? <HospitalRegisterPage /> : <Navigate to={`/${hospitalSlug}/dashboard`} />} 
        />
        
        <Route 
          path="/login" 
          element={!user ? <HospitalLoginPage /> : <Navigate to={`/${hospitalSlug}/dashboard`} />} 
        />

        <Route path="/consultation/:patientId" element={<ConsultationPage />} />

        {/* Dashboard Route */}
        <Route 
          path="/:hospitalName/dashboard" 
          element={user ? <HospitalDashboard /> : <Navigate to="/login" />} 
        />

        {/* In case vera ethavathu wrong URL pouna Landing Page-ke thirumba vara (Optional) */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;